// Same list and order as Ppk2\Format\ConfigureMark::COLORS (PHP).
export const COLORS = ['yellow', 'green', 'blue', 'orange', 'red', 'purple', 'pink', 'teal', 'gray'];
export const DEFAULT_COLOR = 'yellow';